import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { KebabMenu } from '~/components/KebabMenu';
import type { UserListItem } from '~settings/api/lib/schemas';
import { SETTINGS_ROUTES } from '~settings/config/routes';
import { useCanEditUser } from '~settings/modules/user/hooks';

interface ListUserActionsProps {
  user: UserListItem;
}

export function ListUserActions({ user }: ListUserActionsProps) {
  const canEditUser = useCanEditUser(user);
  const { t } = useTranslation('settings', { keyPrefix: 'user' });

  if (!canEditUser) {
    return null;
  }

  return (
    <KebabMenu>
      <KebabMenu.Item asChild>
        <Link
          to={SETTINGS_ROUTES.USER_EDIT(user.id)}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {t('list.editButton')}
        </Link>
      </KebabMenu.Item>
    </KebabMenu>
  );
}

ListUserActions.displayName = 'ListUserActions';
